import { render, staticRenderFns } from "./WorkshopFieldSelection.vue?vue&type=template&id=4e9b5a74"
import script from "./WorkshopFieldSelection.vue?vue&type=script&lang=js"
export * from "./WorkshopFieldSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports